<template lang="html">
  <div class="add-list">
    <Overlay
      width="large"
      :link="{
        name: 'page',
        params: {
          companyId: this.companyId,
          siteId: this.siteId,
          pageId: this.pageId
        }
      }"
    >
      <div class="create-content">
        <div class="widget-fields-wrapper">
          <add-list-form
            v-model="list"
            @submit="submitList"
            @typeChange="handleTypeChange"
            :errors="errors"
            :list-types="sortedListTypeOptions"
            :pageName="pageName"
            :btnLoading="btnLoading"
            :totalLists="lists.length"
          >
          </add-list-form>
        </div>

        <div class="widget-preview-wrapper">
          <WidgetPreviewer
            :demoMode="true"
            :listType="listType"
            :listItem="listItem"
            :listItems="demoData"
          />
        </div>
      </div>
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'
import demoContent from '@/mixins/demoContent'

import AddListForm from '@/components/forms/AddListForm'
import Overlay from '@/components/Overlay'
import WidgetPreviewer from '@/components/WidgetPreviewer'

import {
  createCompanySitePageListData,
  readCompanySitePageListsData
} from '@/lib/lists'
import {readListTypesData, readListTypeData} from '@/lib/list_types'

import {
  createCompanySitePageListListItemData,
  updateCompanySitePageListListItemData
} from '@/lib/list_items'

export default {
  name: 'AddList',

  mixins: [page, demoContent],

  components: {
    AddListForm,
    Overlay,
    WidgetPreviewer
  },

  props: {
    pageId: String,
    companyId: String,
    siteId: String,
    pageName: String
  },

  data() {
    return {
      btnLoading: false,
      list: {},
      lists: [],
      listTypes: [],
      demoData: [],
      listType: {},
      listItem: {},
      errors: {}
    }
  },

  computed: {
    listTypesOptions() {
      return this.listTypes.map((listType) => {
        return {
          key: listType.name,
          value: listType.id,
          created_at: listType.created_at,
          weight: listType.weight
        }
      })
    },

    sortedListTypeOptions() {
      let options = this.listTypesOptions
      return options.sort((a, b) => (a.weight > b.weight ? 1 : -1))
    }
  },

  methods: {
    getData() {
      readListTypesData().then(({data}) => {
        this.listTypes = data
      })

      readCompanySitePageListsData(
        this.companyId,
        this.siteId,
        this.pageId
      ).then(({data}) => {
        this.lists = data
      })
    },

    handleTypeChange() {
      readListTypeData(this.list.list_type_id).then(({data}) => {
        this.listType = data
        let listTypeName = data.name
        this.demoData = this.demoContent[listTypeName].items
      })
    },

    submitList() {
      this.btnLoading = true

      createCompanySitePageListData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.list
      ).then(({data}) => {
        // Create the first list item from the demo data
        let listId = data.id
        let value = this.demoData[0].value
        let hasImage = value.image_url

        let image

        if (hasImage) {
          image = value.image_url
        }

        let firstListItem = {
          key: 'Item 1',
          value: JSON.stringify(value),
          weight: 1
        }

        createCompanySitePageListListItemData(
          this.companyId,
          this.siteId,
          this.pageId,
          listId,
          firstListItem
        ).then(({data}) => {
          if (hasImage) {
            let item = data
            let img = {image: image}

            // Create image for list item
            updateCompanySitePageListListItemData(
              this.companyId,
              this.siteId,
              this.pageId,
              listId,
              item.id,
              img
            ).then(({data}) => {
              this.$router.push({
                name: 'EditListItem',
                params: {
                  companyId: this.companyId,
                  pageId: this.pageId,
                  siteId: this.siteId,
                  listId: listId,
                  listItemId: data.id
                }
              })
            })
          } else {
            this.$router.push({
              name: 'EditListItem',
              params: {
                companyId: this.companyId,
                pageId: this.pageId,
                siteId: this.siteId,
                listId: listId,
                listItemId: data.id
              }
            })
          }
        })
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
